var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.312 22.694 h -0.335 c -0.037 -3.108 -2.573 -5.625 -5.689 -5.625 H 50.062 c -0.709 0 -1.403 -0.288 -1.904 -0.789 l -8.645 -8.645 c -1.075 -1.075 -2.505 -1.667 -4.025 -1.667 H 5.693 C 2.554 5.968 0 8.522 0 11.661 v 56.344 v 8.649 v 2.867 c 0 2.486 2.023 4.51 4.51 4.51 h 79.801 c 3.137 0 5.688 -2.552 5.688 -5.688 V 28.383 C 90 25.246 87.448 22.694 84.312 22.694 z M 6.02 28.383 v 51.139 c 0 0.832 -0.677 1.51 -1.51 1.51 S 3 80.354 3 79.521 v -2.867 v -8.649 V 11.661 c 0 -1.485 1.208 -2.693 2.693 -2.693 h 29.794 c 0.719 0 1.396 0.28 1.904 0.789 l 8.645 8.645 c 1.06 1.06 2.526 1.667 4.025 1.667 h 28.226 c 1.461 0 2.649 1.172 2.686 2.625 H 11.708 C 8.572 22.694 6.02 25.246 6.02 28.383 z M 87 78.344 c 0 1.481 -1.206 2.688 -2.688 2.688 H 8.76 c 0.168 -0.473 0.26 -0.98 0.26 -1.51 V 28.383 c 0 -1.482 1.206 -2.688 2.688 -2.688 h 72.603 c 1.482 0 2.688 1.206 2.688 2.688 V 78.344 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.53929adb0b131b4e0024183dcbe88947.svg";
export { ForwardRef as ReactComponent };